import React, { Component } from 'react'
import { Modal } from 'react-bootstrap';
import { api } from '../../../components/api/api';
import { Alert, AlertErro } from '../../../util/Alertas';

export default class ModalDeposito extends Component {
    constructor(props) {
        super(props)
        this.state = this.initialState;
        this.openModal = (isEdit, id, nome) => isEdit ? this.setState({
            ...this.state,
            id,
            nome,
            show: true,
            isEdit: true
        }) : this.setState({
            ...this.state,
            show: true
        })
    }

    initialState = {
        isEdit: false,
        show: false,
        nome: '',
        id: 0
    }

    onCloseModal = () => this.setState(this.initialState);

    onSubmit = () => {
        if (!this.state.isEdit)
            api.post('/api/Deposito', {
                DepositoId: 0,
                DepositoNome: this.state.nome,
                DepositoStatus: true
            }, res => {
                Alert('Cadastro realizado com sucesso!', true);
                this.props.setDepositos?.(res.data);
            }, err => {
                AlertErro(err);
            })
        else
            api.post('/api/Deposito/Edit', {
                DepositoId: this.state.id,
                DepositoNome: this.state.nome,
                DepositoStatus: true
            }, res => {
                Alert('Deposito atualizado com sucesso!', true);
                this.props.setDepositos?.(res.data);
            }, err => {
                AlertErro(err);
            })
        this.onCloseModal();
    }

    render() {
        const { isEdit, nome, show } = this.state;
        return (
            <Modal show={show}>
                <form onSubmit={e => { e.preventDefault(); this.onSubmit() }}>
                    <Modal.Body>
                        <label>Nome</label>
                        <input
                            required
                            onChange={e => this.setState({ nome: e.target.value })}
                            name='nome'
                            value={nome}
                            className='form-control'
                            type="text"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn btn-danger' onClick={() => this.onCloseModal()}>Fechar</button>
                        <button className='btn btn-primary' type='submit'>{isEdit ? 'Atualizar' : 'Adicionar'}</button>
                    </Modal.Footer>
                </form>
            </Modal >
        )
    }
}
